import React from 'react';
import { FormattedMessage } from 'react-intl';
import Paginator from '../paginator/paginator';
import SectionHeader from '../sectionHeader';
import Search from '../search/Search';
import Summary from '../DataSummary/Summary';
import Table from '../Table/Table';
import styles from '../../modules/PermitManagement/ADP/Logs/logs.module.scss';

 const ListPage=({ tableHeadders, icon, logData, route, page, tags, summary, handleStatusFilter,
   sectionHeader, tabTitle, totalRecords, onSubmitSearch, setPage, searchEnable, forViolations }) => (
      <>
        <SectionHeader
          icon={icon}
          translationID={sectionHeader.id}
          defaultTitle={sectionHeader.default}
          centered>
        <div className={styles.detailHeader} />
        {searchEnable &&<Search onSubmit={e => onSubmitSearch(e)} />}
        </SectionHeader>
        <div style={{ display: 'flex' }} className={styles.toolbar}>
          <div className={styles.counter}>
            <FormattedMessage id={tabTitle.id}
            defaultMessage={tabTitle.default}
            />
          </div>
        </div>
        {summary
        &&<div className={styles.container}>
          <div className={styles.info} style={{ display: 'block' }}>
            <Summary tags={tags} data={summary} handleStatusFilter={handleStatusFilter} />
          </div>
          </div>}
        <div style={{ marginTop: '2vw', marginBottom: '100px' }}>
          <Table
            tableHeadders={tableHeadders}
            logs={logData}
            route={route}
            driverpermit
            forViolations={forViolations}
          />
          {totalRecords !== 0 && (
          <div className={styles.paginatorContainer}>
            <Paginator
              page={page}
              totalRecords={totalRecords}
              pageLimit={20}
              pageNeighbours={1}
              onPageChanged={(pageNo) => { setPage(pageNo); }}
            />
          </div>
         )}
        </div>
      </>
    );

export default ListPage;
